import { useEffect, useRef, useState } from 'react';

const IDLE_LIMIT_SEC = 60 * 60; // 1 saat
const WARN_BEFORE_SEC = 2 * 60; // son 2 dakikada uyarı

/**
 * useIdleLogout — son etkileşimden itibaren geri sayım. 0 olunca onTimeout çağırılır.
 * Etkileşim (mousemove, mousedown, keydown, scroll, touchstart) sayacı sıfırlar.
 */
export default function useIdleLogout({ enabled, onTimeout, onWarn }) {
  const [secondsLeft, setSecondsLeft] = useState(IDLE_LIMIT_SEC);
  const lastActivityRef = useRef(Date.now());
  const warnedRef = useRef(false);

  // Etkileşim dinleyicileri
  useEffect(() => {
    if (!enabled) return;
    const reset = () => {
      lastActivityRef.current = Date.now();
      warnedRef.current = false;
    };
    const evts = ['click', 'keydown', 'touchstart'];
    evts.forEach(e => window.addEventListener(e, reset, { passive: true }));
    return () => evts.forEach(e => window.removeEventListener(e, reset));
  }, [enabled]);

  // Saniyelik geri sayım
  useEffect(() => {
    if (!enabled) return;
    const tick = () => {
      const elapsed = Math.floor((Date.now() - lastActivityRef.current) / 1000);
      const left = Math.max(0, IDLE_LIMIT_SEC - elapsed);
      setSecondsLeft(left);
      if (left <= WARN_BEFORE_SEC && left > 0 && !warnedRef.current) {
        warnedRef.current = true;
        try { onWarn && onWarn(left); } catch { /* ignore */ }
      }
      if (left === 0) {
        try { onTimeout && onTimeout(); } catch { /* ignore */ }
      }
    };
    tick();
    const t = setInterval(tick, 1000);
    return () => clearInterval(t);
  }, [enabled, onTimeout, onWarn]);

  const extend = () => {
    lastActivityRef.current = Date.now();
    warnedRef.current = false;
    setSecondsLeft(IDLE_LIMIT_SEC);
  };

  return { secondsLeft, extend, IDLE_LIMIT_SEC, WARN_BEFORE_SEC };
}
